import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/gcstudent/studentauthentication/StudentAuthPages.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";

const BookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StarIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      fill="#fff"
    />
  </svg>
);

const EyeIcon = ({ show }) =>
  show ? (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

const PROGRAMS = [
  "BSCS (Computer Science)",
  "BSIT (Information Technology)",
  "BS Physics",
  "BS Education",
  "BS Botany",
  "BS Islamic Studies",
  "BS Mathematics",
  "BS Psychology",
  "BS Commerce",
  "BS Zoology",
  "BS Chemistry",
  "BS Economics",
  "BS Fine & Arts",
  "BS Mass Communication Studies",
  "FA",
  "FA (IT)",
  "FSC (Pre Engineering)",
  "FSC (Pre Medical)",
  "ICS (Physics)",
];

const StudentRegisterPage = () => {
  const navigate = useNavigate();
  const { baseUrl, validateRegisterForm } = useContext(AppContext);

  const [cardIn, setCardIn] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [showCPwd, setShowCPwd] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [roll_no, setRoll_no] = useState("");
  const [program, setProgram] = useState("");
  const [session, setSession] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    setTimeout(() => setCardIn(true), 60);
  }, []);

  const clearError = (field) => setErrors((prev) => ({ ...prev, [field]: "" }));

  const registerStudent = (e) => {
    e.preventDefault();
    setApiError("");

    const validationErrors = validateRegisterForm({
      fullName,
      email,
      phone,
      roll_no,
      program,
      session,
      password,
      confirmPassword,
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setLoading(true);

    const formData = new FormData();
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("roll_no", roll_no);
    formData.append("program", program);
    formData.append("session", session);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/student/auth/studentRegister`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        setLoading(false);
        console.log(res.data);
        if (res.data.success === true) {
          Swal.fire({
            icon: "success",
            title: "Registered Successfully!",
            text: "Your account has been created. You can now login.",
            confirmButtonColor: "#213b52",
          }).then(() => {
            navigate("/student/login");
          });
        } else {
          setApiError(
            res.data.message || "Registration failed. Please try again.",
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        const msg =
          error.response?.data?.message ||
          "Something went wrong. Please try again.";
        setApiError(msg);
      });
  };

  return (
    <div className="gcStudent-auth-bg">
      <div
        className={`gcStudent-auth-shell gcStudent-auth-shell--reverse ${cardIn ? "gcStudent-auth-shell--in" : ""}`}
      >
        <div className="gcStudent-auth-side">
          <div className="gcStudent-auth-brand">
            <BookIcon />
            <span>GGCW Library</span>
          </div>

          <div className="gcStudent-auth-badge">
            <StarIcon />
            <span>For Students</span>
          </div>

          <h1 className="gcStudent-auth-side-title">Already a member?</h1>
          <p className="gcStudent-auth-side-sub">
            Already a student? Sign back in to your dashboard and continue your
            journey.
          </p>

          <div className="gcStudent-auth-side-cta">
            <p>Already have an account?</p>
            <button type="button" onClick={() => navigate("/student/login")}>
              Login here →
            </button>
          </div>
        </div>

        <div className="gcStudent-auth-form-side">
          <h2 className="gcStudent-auth-title">Create Account</h2>
          <p className="gcStudent-auth-sub">
            Join GGCW Library as a student and start exploring.
          </p>

          {apiError && <div className="gcStudent-auth-error">{apiError}</div>}

          <form className="gcStudent-auth-form" noValidate>
            <input
              className={`gcStudent-auth-input ${errors.fullName ? "gcStudent-auth-input--error" : ""}`}
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
                clearError("fullName");
              }}
            />
            {errors.fullName && (
              <span className="gcStudent-auth-field-error">
                {errors.fullName}
              </span>
            )}

            <input
              className={`gcStudent-auth-input ${errors.email ? "gcStudent-auth-input--error" : ""}`}
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                clearError("email");
              }}
            />
            {errors.email && (
              <span className="gcStudent-auth-field-error">{errors.email}</span>
            )}

            <div className="gcStudent-auth-row">
              <div className="gcStudent-auth-col">
                <input
                  className={`gcStudent-auth-input ${errors.phone ? "gcStudent-auth-input--error" : ""}`}
                  type="tel"
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    clearError("phone");
                  }}
                />
                {errors.phone && (
                  <span className="gcStudent-auth-field-error">
                    {errors.phone}
                  </span>
                )}
              </div>
              <div className="gcStudent-auth-col">
                <input
  className={`gcStudent-auth-input ${errors.roll_no ? "gcStudent-auth-input--error" : ""}`}
  type="text"
  placeholder="Roll No (e.g. CS-21, FA-1412)"
  value={roll_no}
  onChange={(e) => {
    setRoll_no(e.target.value);
    clearError("roll_no");
  }}
/>
                {errors.roll_no && (
                  <span className="gcStudent-auth-field-error">
                    {errors.roll_no}
                  </span>
                )}
              </div>
            </div>

            <div className="gcStudent-auth-row">
              <div className="gcStudent-auth-col">
                <select
                  className={`gcStudent-auth-input ${errors.program ? "gcStudent-auth-input--error" : ""}`}
                  value={program}
                  onChange={(e) => {
                    setProgram(e.target.value);
                    clearError("program");
                  }}
                >
                  <option value="">Select Program</option>
                  {PROGRAMS.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
                {errors.program && (
                  <span className="gcStudent-auth-field-error">
                    {errors.program}
                  </span>
                )}
              </div>
              <div className="gcStudent-auth-col">
                <input
                  className={`gcStudent-auth-input ${errors.session ? "gcStudent-auth-input--error" : ""}`}
                  type="text"
                  placeholder="Session (e.g. 2022-2026)"
                  value={session}
                  onChange={(e) => {
                    setSession(e.target.value);
                    clearError("session");
                  }}
                />
                {errors.session && (
                  <span className="gcStudent-auth-field-error">
                    {errors.session}
                  </span>
                )}
              </div>
            </div>

            <div className="gcStudent-auth-pwd-wrap">
              <input
                className={`gcStudent-auth-input ${errors.password ? "gcStudent-auth-input--error" : ""}`}
                type={showPwd ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  clearError("password");
                }}
              />
              <button
                type="button"
                className="gcStudent-auth-eye"
                onClick={() => setShowPwd((p) => !p)}
              >
                <EyeIcon show={showPwd} />
              </button>
            </div>
            {errors.password && (
              <span className="gcStudent-auth-field-error">
                {errors.password}
              </span>
            )}

            <div className="gcStudent-auth-pwd-wrap">
              <input
                className={`gcStudent-auth-input ${errors.confirmPassword ? "gcStudent-auth-input--error" : ""}`}
                type={showCPwd ? "text" : "password"}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  clearError("confirmPassword");
                }}
              />
              <button
                type="button"
                className="gcStudent-auth-eye"
                onClick={() => setShowCPwd((p) => !p)}
              >
                <EyeIcon show={showCPwd} />
              </button>
            </div>
            {errors.confirmPassword && (
              <span className="gcStudent-auth-field-error">
                {errors.confirmPassword}
              </span>
            )}

            <button
              type="button"
              className={`gcStudent-auth-btn ${loading ? "gcStudent-auth-btn--loading" : ""}`}
              disabled={loading}
              onClick={registerStudent}
            >
              {loading ? (
                <span className="gcStudent-auth-spinner" />
              ) : (
                "Register"
              )}
            </button>
          </form>

          <button className="gcStudent-auth-back" onClick={() => navigate("/")}>
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentRegisterPage;